import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './graphql/User'

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on Address {
    id
    shortname
  }
`

export const COMPANY_STAFF_FRAGMENT = gql`
  fragment CompanyStaffFragment on CompanyStaff {
    id
    contactId
    role
    isRepresentant
    prefix
    firstname
    lastname
    birthDate
    birthPlace
    birthCountry
    nationality
    socialSecurityNumber
    postalAddress
    emailAddress
    father
    mother
    hiddenAddress
    maritalStatus
    siren
    socialDenomination
    socialCapital
    socialPlace
    greffe {
      id
      name
    }
    legalStatus {
      id
      name
    }
    shares
    createdAt
    updatedAt
  }
`

export const CONTACT_DETAIL_FRAGMENT = gql`
  fragment ContactDetailFragment on ContactDetail {
    id
    firstname
    lastname
    phoneNumber
    email
  }
`

export const SOCIETY_FRAGMENT = gql`
  fragment SocietyFragment on Society {
    id
    actionType
    activity
    name
    brandName
    legalStatus {
      id
      name
    }
    startingDate
  }
`

export const FICHE_COMPONENT_FRAGMENT = gql`
  fragment FicheComponentFragment on FicheComponent {
    id
    title
    subtitle
    displayOrder
    content
  }
`

export const BASE_DOMICILIATION_FRAGMENT = gql`
  fragment BaseDomiciliationFragment on Domiciliation {
    id
    paymentType
    address {
      ...AddressFragment
    }
    contactDetail {
      ...ContactDetailFragment
    }
    society {
      ...SocietyFragment
    }
  }
  ${ADDRESS_FRAGMENT}
  ${CONTACT_DETAIL_FRAGMENT}
  ${SOCIETY_FRAGMENT}
`

export const CONTACT_FRAGMENT = gql`
  fragment ContactFragment on Contact {
    id
    countryConfig {
      id
      countryName
    }
    clientSince
    domiciliation {
      ...BaseDomiciliationFragment
    }
    society {
      ...SocietyFragment
    }
    contactDetail {
      ...ContactDetailFragment
    }
  }
  ${BASE_DOMICILIATION_FRAGMENT}
  ${CONTACT_DETAIL_FRAGMENT}
  ${SOCIETY_FRAGMENT}
`

export const FICHE_COMPARATIVE_FRAGMENT = gql`
  fragment FicheComparativeFragment on FicheComparative {
    id
    metaTitle
    metaDescription
    countryConfig {
      id
      countryName
    }
    comparativeChart {
      ...FicheComponentFragment
    }
    customerReviews {
      ...FicheComponentFragment
    }
    mainTitle {
      ...FicheComponentFragment
    }
    illustratedTexts {
      ...FicheComponentFragment
    }
    nextStep {
      ...FicheComponentFragment
    }
  }
  ${FICHE_COMPONENT_FRAGMENT}
`

export const COUNTRY_CONFIG_FRAGMENT = gql`
  fragment CountryConfigFragment on CountryConfig {
    id
    countryCode
    countryName
    hasFicheComparative
  }
`

export const PAGINATION_FRAGMENT = gql`
  fragment PaginationFragment on Pagination {
    page
    pageLength
    total
  }
`

export const PURCHASE_FRAGMENT = gql`
  fragment PurchaseFragment on Purchase {
    id
    amount
    status
    identificationToken
    specialOffer
  }
`

export const LEGAL_FORMALITY_STATUS_HISTORIC_FRAGMENT = gql`
  fragment LegalFormalityStatusHistoricFragment on LegalFormalityStatusHistoric {
    id
    initial
    final
    attachments
    createdAt
  }
`
export const LEGAL_FORMALITY_LAST_STATUS_HISTORIC_FRAGMENT = gql`
  fragment LegalFormalityLastStatusHistoricFragment on LegalFormalityLastStatusHistoric {
    final
    lastDate
  }
`

// TODO: use this fragment instead of hardcoding things in the next fragment
export const LEGAL_FORMALITIES_DOCUMENT_FRAGMENT = gql`
  fragment LegalFormalitiesDocumentFragment on LegalDocument {
    id
    createdAt
    documentType
    state
    fileRecto
    fileVerso
    legalDocumentableType
    legalDocumentableId
    state
    checks {
      id
      status
      instructions
      refusalReason
      help
      position
    }
  }
`

export const LEGAL_FORMALITY_FRAGMENT = gql`
  fragment LegalFormalityFragment on LegalFormality {
    id
    uuid
    assignedUser {
      ...UserFragment
    }
    authorityRefusalReason
    documentList {
      documentType
      tags
      target {
        type
        id
        label
      }
      required
      mergeable
    }
    documents {
      ...LegalFormalitiesDocumentFragment
    }
    formData
    formCategories
    formProvider
    internalNotes
    isRollbackable
    lastStatusesHistorics {
      ...LegalFormalityLastStatusHistoricFragment
    }
    metadatum
    purchase {
      ...PurchaseFragment
    }
    status
    steps
    finishedSteps
    tags
    validatedFormData

    createdAt
  }
  ${LEGAL_FORMALITY_LAST_STATUS_HISTORIC_FRAGMENT}
  ${PURCHASE_FRAGMENT}
  ${USER_FRAGMENT}
  ${LEGAL_FORMALITIES_DOCUMENT_FRAGMENT}
`

export const GREFFE_FRAGMENT = gql`
  fragment GreffeFragment on Greffe {
    id
    name
  }
`
export const FREE_ANSWER_FRAGMENT = gql`
  fragment FreeAnswerFragment on FreeAnswer {
    id
    addressId
    addressName
    forwardedAt
    createdAt
    trackingNumber
  }
`
